import { http, type HttpClient } from './core/http-client';
import type { AdminPlan, AdminPlanList, AdminPlanUpdate } from './models';

// Staff: plan names, prices and limits. Super admins, and admins switched on for it.
export class AdminPlanService {
  constructor(private readonly http: HttpClient) {}

  list = () => this.http.get<AdminPlanList>('/admin/plans');

  update = (id: string, body: AdminPlanUpdate) =>
    this.http.put<AdminPlan & { changed: boolean }>(`/admin/plans/${id}`, body);
}

export const adminPlanService = new AdminPlanService(http);
